import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import _t from 'i18n!nls/author-common';

import 'css!./__styles__/CharacterLimitError';

type Props = {
  count: number;
  max: number;
  min: number;
};

const CharacterLimitError = (props: Props) => {
  const { count, max, min } = props;

  return (
    <div className="rc-CharacterLimitError">
      {count > max && <FormattedMessage message={_t('Maximum {max} characters')} max={max} />}

      {min !== 1 && count < min && <FormattedMessage message={_t('Minimum {min} characters')} min={min} />}
    </div>
  );
};

export default CharacterLimitError;
